package com.example.mystybag.communication.utils

import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.sharedmodels.defines.ServerStatusDefines.Companion.STATUS_NO_INTERNET_CONNECTION
import com.example.mystybag.sharedmodels.defines.ServerStatusDefines.Companion.STATUS_TIMEOUT
import com.example.mystybag.sharedmodels.defines.ServerStatusDefines.Companion.STATUS_TOKEN_IS_EXPIRED

object Response {
    fun getErrorMessage(status: Int, apiEndPoint: String, statusMessage: String? = null): String {
        if (!statusMessage.isNullOrBlank()) return statusMessage
        if (status == STATUS_TOKEN_IS_EXPIRED)          return sharedString(SR.strings.please_log_in_again)
        if (status == STATUS_NO_INTERNET_CONNECTION)    return sharedString(SR.strings.no_internet_connection)

        return if (status == STATUS_TIMEOUT)
            sharedString(SR.strings.service_temporarily_unavailable)
        else
            sharedString(SR.strings.an_error_occurred_please_try_again_later)
    }
}